import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { mainURL, prodURL } from "../../utils/common";
import { LeftSocialMediaIconUI } from "../../components/LeftSocialMediaIconUI";
import { DownloadFileByFileStoreId } from "../../components/DownloadFileByFileStoreId";
import { ReDirectToeKMC2 } from "../../components/ReDirectToeKMC2";

const sitemapData = [

  {
    title: "Kmc Home page",
    children: [
      { title: "Home", url: "/kmc-portal", type: "link" },
      { title: "Quick Links", url: "/Quick_Links", type: "link" },
      { title: "EODB Dashboard", url: "/Dashboard", type: "link" },
      { title: "RTI",
        url: `${prodURL}/rti`,
        type: "anchor",
      },
      { title: "Tender",
      children: [
        { title: "Tender Barta", url: `${prodURL}/tender-details/tenderbarta`, type: "anchor", },
        { title: "Tender Form Format",
        fileStoreId: "707e81fa-2b27-452a-8352-abddf211b88b",
        type: "filestore",
      }, 
      ],
    },
    { title: "Contact", url: "/Contact_Us_Home", type: "link" },
    { title: "More",
      children: [
        { title: "Circulars", url: `${prodURL}/tender-details/circularnotices`, type: "anchor", },
      ],
    },

    ],
  },


  {
    title: "Home page Site Menu",
    children: [

      // { title: "KMC Departments", url: "/KMC_Department", type: "link" },
      { title: "Municipal History", url: "/MunicipalHistory", type: "link" },
      { title: "KMC Contacts", url: "/Contact_Us_Home", type: "link" },
      { title: "EODB Dashboard - Online Services", url: "/Dashboard", type: "link" },
      { title: "Property Tax Quick Pay",
        url: `${prodURL}/citizen/withoutAuth/online-payment`,
        type: "anchor",
      },
      { title: "CE (Licence) Pay",
        url: `https://kmcuat.wb.gov.in/citizen/withoutAuth/license-payment?screenType=main`,
        type: "anchor",
      },
      { title: "SWM Pay",
        url: `https://kmcuat.wb.gov.in/citizen/withoutAuth/license-payment?screenType=swm`,
        type: "anchor",
      },

      { title: "Encumbrance Certificate",
        url: `https://www.kmcgov.in/KMCPortal/jsp/EncumbranceCertificate.jsp`,
        type: "redirect",
      },
      { title: "About Kolkata", url: "/About_Kolkata", type: "link" },
      { title: "Citizen Charter", url: "/Citizen_charter_Home", type: "link" },
      { title: "Citizen Charter", url: "/Citizen_charter_Home", type: "link" },
      { title: "Tender Form Format",
        fileStoreId: "b534700d-b98e-4687-bccd-2a9a25863384",
        type: "filestore",
      },
      { title: "Tender Barta",
        url: `${prodURL}/tender-details/tenderbarta`,
        type: "anchor",
      },
      { title: "eAuction", url: "/Auction", type: "link" },
      { title: "Employee Dashboard",
        url: `${prodURL}/employee/language-selection`,
        type: "anchor",
      },
      { title: "Hearing/ Case Search",
        url: `${prodURL}/commonhearing/`,
        type: "anchor",
      },
      { title: "Building Work Diary Report",
        url: `${prodURL}/tender-details/workdiaryReport`,
        type: "anchor",
      },

      { title: "Procurement Digital Library(Tender & Work Order Details)",
        children: [
          { title: "Employee",
          url: `${prodURL}/employee/language-selection`,
          type: "anchor",
         },
         { title: "Citizen",
         url: `${prodURL}/tender-details/`,
         type: "anchor",
        },
        ],
      },
      { title: "Downloadable Forms", url: "/DownloadableForms", type: "link" },

      { title: "Statutory Forms",
      children: [
        { title: "HVC-NCSK/2026",
        fileStoreId: "f54f4b8a-40d9-4242-bb8f-81c7675300bc",
        type: "filestore",
       },     
      ],
    },

    { title: "Publications", url: "/E_News_Letter", type: "link" },

    { title: "Project",
      children: [
        { title: "1. CBP",
        url: "/CBP_Home", 
        type: "link"
       },
       { title: "2. MPLAD / BEUP",
        url: "/Mpnld", 
        type: "link"
       },     
      ],
    },
    
    { title: "HR System",
      children: [
        { title: "Notification",
        fileStoreId: "063f9d96-5752-425b-b1a2-38fa823a80a5",
        type: "filestore",
       },
       { title: "Office Order/Circular",
        url: "/OfficeOrderCircular", 
        type: "link"
       },     
      ],
    },
    { title: "Sexual Harassment-Redressal Cell",
      children: [
        { title: "Important Points for making Complaints",
        fileStoreId: "b5a58351-96f7-445b-b6db-a4b0e2bd7dd4",
        type: "filestore",
       },
       { title: "Sexual Harassment of Women at Work place(Prevention,Prohibition and Redressal)Act,2013",
        fileStoreId: "d4d540c3-ab1c-48a4-9a0f-77a3e0293874",
        type: "filestore",
       },
       { title: "Ch.Manager(P)'s Circular No.20/SHC of 2018-19 dated 19.06.2018",
        fileStoreId: "a21d501f-187c-4127-95d2-00affc6e5dda",
        type: "filestore",
       },
       { title: "Chief Manager(Personal)'s Circular No.26/SHRC of 2021-22 dated 27.07.2021",
        fileStoreId: "29ba3c8a-1a37-4862-a509-e09467b40420",
        type: "filestore",
       },
       { title: "Chief Manager(Personal)'s Circular No.19/SHRC of 2024-25 dated 06.08.2024",
        fileStoreId: "08337512-be9a-4905-9e64-b9c5a0bd6517",
        type: "filestore",
       },
            
      ],
    },

    { title: "ROWLogin", type: "redirect" },

    { title: "Grievance Redressal", url: "/Procedure", type: "link" },

    { title: "Grievance KMC 2.0", 
    url: `${prodURL}/citizen/language-selection`, type: "anchor", },

    { title: "Recruitment / Result/Training", url: "/KMC_Recruitments", type: "link" },
    { title: "Circular & MIC Resolution", 
    url: `${prodURL}/tender-details/circularnotices`, type: "anchor", },
    { title: "RTI", 
    url: `${prodURL}/rti/`, type: "anchor", },
    
    { title: "Document Authentication ",
      children: [
        { title: "Assessment PD/FS", type: "redirect" }, 
        { title: "Assessment LOI", type: "redirect" },
        { title: "Assessment Suspense", type: "redirect" },
        { title: "License(CE)", url: `https://kmcuat.wb.gov.in/citizen/withoutAuth/license-payment?screenType=main`, type: "redirect" },
        { title: "Building", type: "redirect" },
        { title: "Birth Certificate", type: "redirect" },
        { title: "Death Certificate", type: "redirect" },       
      ],
    },

    { title: "COMPENDIUM OF IMPORTANT DEPARTMENTAL CIRCULARS / ORDERS",
      children: [
        { title: "FY 2010-11",
        fileStoreId: "bee1ed2c-73d7-4236-8fe6-2588d0bc9e68",
        type: "filestore",
       },
       { title: "FY 2011-12",
        fileStoreId: "28f380a9-80c0-43b2-beaf-2593d5ffcd5e",
        type: "filestore",
       },
       { title: "FY 2012-13",
        fileStoreId: "6ebdc025-9c3c-4c3c-8f9c-21cfb544a042",
        type: "filestore",
       },
       { title: "FY 2013-14",
        fileStoreId: "cd1513aa-8d2b-49eb-960d-1e9effefb978",
        type: "filestore",
       },
            
      ],
    },

    { title: "West Bengal Right to Public Service Act,2013", 
    fileStoreId: "19250074-7075-4a48-add0-62b8226e8d19", type: "filestore", },

    { title: "Guidelines of Section 199(2) of KMC Act,1980 (as amended in 2019)", 
    fileStoreId: "b70563a0-1496-49cf-b607-6cbf8e5ce2d7", type: "filestore", },


    ],
  },

  {
    title: "KMC Departments",
    children: [
      { title: "KMC Departments", url: "/KMC_Department", type: "link" },
      { title: "Vision", url: "/AboutUs", type: "link" },
      { title: "Overview", url: "/Overview", type: "link" },
      { title: "KMC Functions", url: "/KMCFunctions", type: "link" },
      { title: "e-Kolkata Centers", url: "/EKolkataCenter", type: "link" },
      { title: "Basic Statistics", url: "/Basic_Statistic", type: "link" },
      { title: "Emblem", url: "/Emblem", type: "link" },
      { title: "KMC Budget", url: "/KMCBudget", type: "link" },
      { title: "KMC Structure", fileStoreId: "18009126-2a59-4f3c-8a94-891f18042026", type: "filestore", },
      { title: "KMC Financial Statements", url: "/KMC_Department", type: "link" },

    ],
  },


  {
    title: "Online Payment ",
    children: [
      {
        title: "Property Tax",
        children: [
          { title: "All Bill", url: `${prodURL}/citizen/withoutAuth/online-payment`, type: "anchor", },
          { title: "Suspense", url: `${prodURL}/citizen/language-selection`, type: "anchor", },
        ],
      },

      { title: "Building", type: "redirect" },
      { title: "CE (Licence Dept.)", type: "redirect" },
      { title: "Ch. Valuer & Surveyor", url: `${prodURL}/citizen/language-selection`, type: "anchor", },

      {
        title: "Civil Payment",
        children: [
          { title: "Chokage", url: `${prodURL}/citizen/language-selection`, type: "anchor", },
          { title: "Planned Cutting", url: `${prodURL}/citizen/language-selection`, type: "anchor", },
          { title: "Road Cutting", url: `${prodURL}/citizen/language-selection`, type: "anchor", },
          { title: "Small Cutting", url: `${prodURL}/citizen/language-selection`, type: "anchor", },
        ],
      },
      {
        title: "Amusement",
        children: [
          { title: "Amusement Fees (Renew/Casual/New)", type: "redirect" },
          { title: "Casual Demand Generation and payment", type: "redirect" },
        ],
      },
      {
        title: "Market",
        children: [
          { title: "Water Supply Services", type: "redirect" },
          { title: "Misclennious Demand", type: "redirect" },
        ],
      },
      { title: "Parking", url: `${prodURL}/citizen/language-selection`, type: "anchor", },
      { title: "Advertisement", type: "redirect" },
      { title: "Water Supply", url: `${prodURL}/citizen/language-selection`, type: "anchor", },
      { title: "Drainage", url: `${prodURL}/citizen/language-selection`, type: "anchor", },
      { title: "Uttaran Services", url: `${prodURL}/citizen/language-selection`, type: "anchor", },

    ],
  },


  {
    title: "Online Services",
    children: [

      { title: "Advertisement", url: "/KMC_Advertisement", type: "link" },
      { title: "Amusement", url: "/Amusement", type: "link" },
      { title: "Assessment Collection", url: "/Assessment_Collection_Assessment_Home", type: "link" },
      { title: "Birth/Death Registration", url: "/Birth_Death_Ragistration", type: "link" },
      { title: "Building Sanction", url: "/Building_Sanction_Building_Home", type: "link" },
      { title: "Uttaran Services", url: "/KMC_Bustee_services", type: "link" },
      { title: "Car Parking", url: "/Car_Parking_Home", type: "link" },
      { title: "Central Records", url: "/KMC_Central_records_Home", type: "link" },
      { title: "CH.VS Dept", url: "/CH_VS_Dept_Download_Forms", type: "link" },
      { title: "Drainage", url: `${prodURL}/citizen/language-selection`, type: "anchor", },
      { title: "Education", url: "/Education_part", type: "link" },
      { title: "Engineering (Civil)", url: "/Engineering_Home", type: "link" },
      { title: "Health Services", url: "/Health_services_Health_Home", type: "link" },
      { title: "Environment & Heritage", url: "/HeritageBuildingHome", type: "link" },
      { title: "Information Technology", url: "/Contact_Us_Home", type: "link" },
      { title: "KMCP Schools", url: "/Kmc_school_home", type: "link" },
      { title: "Licence", url: "/Certificate_of_Enlistment", type: "link" },
      { title: "Lighting", url: "/Lighting_Home", type: "link" },
      { title: "Market", url: "/KMC_market_list", type: "link" },
      { title: "Parks & Squares", url: "/Parks_and_gardens", type: "link" },
      { title: "Personnel", url: "/OfficeOrderCircular", type: "link" },
      { title: "Sewerage & Drainage", url: "/Drainage_Home", type: "link" },
      { title: "Social Welfare & Urban Poverty Alleviation", url: "/Social_welfare_Download_Forms", type: "link" },
      { title: "Solid Waste Management", url: "/Solid_wastes_home", type: "link" },
      { title: "Water Supply", url: "/Water_Supply", type: "link" },
     
    ],
  },


  {
    title: "Footer",
    children: [
      { title: "Recruitment / Result/Training", url: "/KMC_Recruitments", type: "link" },
      { title: "Downloadable Forms", url: "/DownloadableForms", type: "link" },
      { title: "Grievance Redressal", url: "/Procedure", type: "link" },
      { title: "Encumbrance Certificate", url: "https://www.kmcgov.in/KMCPortal/jsp/EncumbranceCertificate.jsp", type: "link" },
      { title: "Circulars", url: `${prodURL}/tender-details/circularnotices`, type: "anchor", },
      { title: "Site map", url: "/SiteMap", type: "link" }, 
      { title: "Disclaimer", url: "/Disclaimer", type: "link" },
      { title: "Feedback", url: "https://www.kmcgov.in/KMCPortal/jsp/PortalFeedback.jsp", type: "link" },
      { title: "Faq", url: "/Faqs", type: "link" },
      { title: "Contact Us", url: "/Contact_Us_Home", type: "link" },
      { title: "EODB Dashboard-Online", url: "/Dashboard", type: "link" },
    ],
  },

  {
    title: "Important Links",
    children: [
      { title: "Official Website of West Bengal Govt", url: "https://wb.gov.in/", type: "link" },
      { title: "Municipal Service Commission", url: "https://www.mscwb.org/", type: "link" },
      { title: "KEIIP", url: "http://www.keiip.in/", type: "link" },
      { title: "Silpasathi", url: "http://www.keiip.in/", type: "link" },
      { title: "Air Quality Information System,WBPCB", url: "http://emis.wbpcb.gov.in/airquality/citizenreport.do", type: "link" },
      { title: "Bangla Sahayata Kendra(Citizen Login)", url: "https://bsk.wb.gov.in/citizenlogin", type: "link" },    

    ],
  },
  
  
];

const SiteMapItem = ({ item, level = 0 }) => {
  const type = item.type || "link";

  const renderLink = () => {
    switch (type) {
      case "redirect":
        return <a className="sitemap-link" href={`${mainURL}/citizen/language-selection`} target="_blank" rel="noreferrer">
          {item.title}
        </a>
      case "anchor":
        return (
          <a className="sitemap-link" href={item.url} target={item.target || undefined}
            rel={item.target === "_blank" ? "noreferrer" : undefined} >
            {item.title}
          </a>
        );

      case "filestore":
        return <a className="sitemap-link" href={`${mainURL}/filestore/v1/files/id?fileStoreId=${item.fileStoreId}&tenantId=km.kolkata`} >
          <i className="bi bi-download mr-2"></i>
          {item.title}
        </a>


      case "link":
      default:
        return (
          <Link to={item.url} className="sitemap-link"> {item.title} </Link>
        );
    }
  };

  return (
    <li className={`sitemap-item level-${level}`}>
      {item.children ? (
        <>
          <div className="sitemap-folder">
            <span className="folder-icon">
              {level === 0 ? "" : "›"}
            </span>
            {item.title}
          </div>

          <ul className="sitemap-children">
            {item.children.map((child, index) => (
              <SiteMapItem
                key={`${child.title}-${index}`}
                item={child}
                level={level + 1}
              />
            ))}
          </ul>
        </>
      ) : (
        renderLink()
      )}
    </li>
  );
};


const SiteMap = () => {
  return (
    <div className="sitemap-page">
      <div className="container">
        <div className="row inner-pad1">
          <div className="col-12">
            <div className="sitemap-header">
              <h1>Site Map</h1>
            </div>
          </div>
        </div>

        <div className="row">
          {sitemapData.map((item, index) => (
            <div className="col-lg-4 col-md-4 col-sm-12 mb-4 d-flex"
              key={`${item.title}-${index}`}>
              <SiteMapItem item={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SiteMap;
